export const UnsavedInheritanceKey = 'unsaved-inheritance-changes';
